<template>
  <div>
    <div class="row evollu-form">
      <!--Created At Filter --->

    </div>

    <v-server-table
      :id="componentRef"
      :ref="componentRef"
      :name="componentRef"
      :columns="columns"
      :options="tableOptions"
      @loaded="onLoaded"
      @loading="onLoading"
      @row-click="handleLeadClicked"
      @filter="onFilterUpdate"
    >
      <span slot="createdAt" class="no-break" slot-scope="props">{{ props.row.createdAt | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="name" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.name ? props.row.person.name : "N/A" : "N/A"}}</span>
      <span slot="email" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.email ? props.row.person.email : "N/A" : "N/A"}}</span>
      <span slot="mobilePhone" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.mobilePhone ? props.row.person.mobilePhone : "N/A" : "N/A"}}</span>
      <span slot="entity" class="no-break" slot-scope="props"> {{handleEntityName(props.row)}}</span>
      <span slot="anamnese" class="no-break" slot-scope="props"> {{handleAnamnesesNames(props.row)}}</span>


    </v-server-table>

    <AnamneseDetails
      v-if="selectedLead"
      :anamneseAnswers="selectedLead.anamnesesAnswers"
      @cancel="selectedLead = null"
    />

  </div>
</template>

<script>
 import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin.vue';
 import TableQueryMixin from '@/mixins/TableQueryMixin.vue';
 import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
 import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
 import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
 import Multiselect from 'vue-multiselect';
 import AnamneseDetails from '@/components/evohealth/leads/anamneses/AnamneseDetails.vue';

 export default {
   components: { AnamneseDetails, Multiselect, RangeDatePicker },
   props: {
     componentRef: {
       type: String,
       required: true
     },
     authorizedEntities: {
       type: Array,
       required: true,
     },
     filters: {
       type: Object,
       required: true
     }
   },
   mixins: [
     IsFromEvolluMixin,
     TableQueryMixin,
     MultiselectLabelFormatter,
     ClustersAndEntitiesMixin
   ],
   data () {
     return {
       columns: ['createdAt', 'name', 'email', 'mobilePhone', 'entity', 'anamnese'],
       tableOptions: {
         orderBy: {
           column: 'createdAt',
           ascending: false
         },
         saveState: true,
         storage: 'local',
         filterable: true,
         sortable: ['createdAt'],
         customFilters: ['start', 'end', 'entities'],
         headings: {
           createdAt: this.$t('leads.table.created_at'),
           name: this.$t('biosigns.columns.name'),
           email: this.$t('biosigns.columns.email'),
           mobilePhone: this.$t('biosigns.columns.mobilePhone'),
           entity: this.$t('biosigns.columns.entity'),
           anamnese: this.$t('evohealth.questionnaires.title')
         },
         columnsClasses: {
           createdAt: 'created_at',
         }
       },
       selectedLead: null,
     }
   },
   async mounted() {
     //const healthParamsNames = this.healthParams.map(param => param.name)
     //this.columns.push(...healthParamsNames)
     if(this.authorizedEntities && this.authorizedEntities.length === 1) {
       this.filters.anamnesesEntities = [this.authorizedEntities[0]]
     }
   },
   methods: {
     reload: function () {
       this.$refs[this.componentRef].refresh()
     },
     onLoading: function () {
       this.$emit('loading')
     },
     onLoaded: function (state) {
       this.$emit('loaded', state)
     },
     handleLeadClicked: function ({ row }) {
       this.selectedLead = row
     },
     handleEntityName: function (lead) {
       if(lead.entityId !== null) {
         const entity = this.authorizedEntities.find(entity => entity.id === lead.entityId)
         if(entity) {
           lead.entity = entity
           return entity.name
         }
       }

       return "N/A"
     },
     handleAnamnesesNames: function (lead) {
       if(lead.anamnesesAnswers && lead.anamnesesAnswers.length > 0) {
         return lead.anamnesesAnswers.map(anamnese => anamnese.anamneseTitle).join('; ')
       }

       return "N/A"
     }
   },
   computed: {
     queryUrl: function() {
       return `${this.$store.state.evohealth_server}v1/leads/anamneses/all`
     }
   },
   watch: {
     'filters.date': function (value) {
       this.$refs[this.componentRef].customQueries.start = value.start || ''
       this.emitTableFilter(`vue-tables.${this.componentRef}.filter::end`, value.end || '')
     },
     'filters.anamnesesEntities': function (value) {
       if (value) {
         const parsedIds = value.map(elem => parseInt(elem.id)).join(',')
         this.emitTableFilter(`vue-tables.${this.componentRef}.filter::entities`, parsedIds || '')
       }
     }
   }
 }

</script>


<style scoped lang="scss">

</style>
